import { Auth0Provider } from "@auth0/auth0-react";
import { useGRIP } from "@nib/grip-react";
import { navigate } from "gatsby";
import React, { PropsWithChildren } from "react";

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const { deviceId, clientId, audience, domain, handOffNonce } = useGRIP();

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        handOffNonce,
        deviceId,
        redirect_uri: process.env.GATSBY_AUTH_REDIRECT_URI,
        scope: "grip-token-version:3",
      }}
      onRedirectCallback={(appState) => {
        if (appState?.returnTo) {
          void navigate(appState.returnTo.replace(process.env.GATSBY_PATH_PREFIX as string, "/"), {
            replace: true,
          });
        }
      }}
    >
      {children}
    </Auth0Provider>
  );
};
